export const AUTH_UNAUTHORIZED_EVENT = 'genbadock:auth-unauthorized'

export function dispatchAuthUnauthorized(): void {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(new Event(AUTH_UNAUTHORIZED_EVENT))
}
